import { IconButton, SettingIcon } from '@devrangex/rui'
import styled from '@emotion/styled'
import { useState } from 'react'
import { Cookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'


const StyledSettingMenuContainer = styled.div`
    position: relative;
`

const StyledSettingMenu = styled.div`
    position: absolute;
    background-color: ${({theme}) => theme.background.elevated};
    border: 1px solid ${({theme}) => theme.background.grouped};
    border-radius: 2px;
    bottom: -36px;
    right: 16px;

    ::after {
        content: '';
        position: absolute;
        top: -12px;
        right: 10px;
        border-width: 6px;
        border-style: solid;
        border-color: ${({theme}) => theme.background.grouped} transparent
            transparent transparent;
        transform: rotate(180deg);
    }
`

const StyledSettingMenuItem = styled.li`
    list-style: none;
    ${({theme}) => theme.font.caption};
    padding: 12px 14px;
    min-width: 92px;
`

export default function SettingMenu() {
  const navigate = useNavigate()
  const [toggle, setToggle] = useState(false)

  const onClickLogout = () => {
    const cookies = new Cookies()
    cookies.remove('accessToken')
    cookies.remove('refreshToken')

    navigate('/login', {replace: true})
  }

  return (
    <StyledSettingMenuContainer>
      <IconButton
        size="lg"
        onClick={() => setToggle((cur) => !cur)}
        role="button"
      >
        <SettingIcon/>
      </IconButton>

      {toggle && (
        <StyledSettingMenu>
          <StyledSettingMenuItem
            onClick={onClickLogout}
            data-testid="button-logout"
          >
            로그아웃
          </StyledSettingMenuItem>
          <StyledSettingMenuItem>
            버전: {import.meta.env.VITE_DEPLOY_VERSION}
          </StyledSettingMenuItem>
        </StyledSettingMenu>
      )}
    </StyledSettingMenuContainer>
  )
}
